import * as React from 'react';

import { Checkbox, DatePicker, TextInput } from '../components/forms';
import Utils , { Validation } from '../common/utils';

interface Props {
	className?: string;
	application: CustomerPolicy;
	onPolicyChange: (e: any) => void;
	onOverwirteChange: (e: any) => void;
	readOnly: boolean;
	isLoading: boolean;
	overwriteRate: boolean;
	isAdjudicator: boolean;
}
const ApplicationDetailsForm: React.StatelessComponent<Props> = props => {	
	const isPremiumReadOnly = props.readOnly || !props.overwriteRate;
	const softDeclinedHeader = props.application.isSoftDeclined ? ' - Soft Declined' : '';
	return (
		<div className={props.className}>
			<div className="table-options">
				<h2 className="form-fieldset-title">
					Application #: {props.application.number} ({Utils.getPickListItemDescription(props.application.statusId)})
					{softDeclinedHeader}{props.application.adjudicationStatusId && ' - '}
					{Utils.getPickListItemDescription(props.application.adjudicationStatusId)}
				</h2>
			</div>

			<div className="form-fieldset">
				<div className="row align-items-top">
					<DatePicker
						labelText="Start Date"
						name="effectiveDate"
						value={props.application.effectiveDate}
						className="col-md-3"
						disabled={props.readOnly}
						onChange={props.onPolicyChange}
						error={Validation.validateDate(props.application.effectiveDate, 'YYYY-MM-DD', true)}
					/>
					<DatePicker
						labelText="End Date"
						name="endDate"
						value={props.application.endDate}
						className="col-md-3"
						disabled={true}
						onChange={props.onPolicyChange}
						error={Validation.validateDate(props.application.endDate, 'YYYY-MM-DD', true)}
					/>
					<TextInput
						labelText="Coverage Amount"
						name="coverageAmount"
						pattern="[0-9]*"
						value={props.readOnly ?
							Utils.formatCurrency(props.application.coverageAmount, 0) : props.application.coverageAmount}
						className="col-md-4"
						disabled={props.readOnly || props.isAdjudicator}
						onChange={props.onPolicyChange}
					/>
				</div>
				<div className="row align-items-center">
					<TextInput
						labelText="Term"
						name="term"
						pattern="[0-9]*"
						value={props.application.term}
						className="col-md-3"
						disabled={props.readOnly || props.isAdjudicator}
						onChange={props.onPolicyChange}
						error={Validation.validateTerm(props.application.term)}
					/>
					<TextInput
						labelText="Premium Amount"
						name="rate"
						pattern="[0-9\.]*"
						value={isPremiumReadOnly ?
							Utils.formatCurrency(props.application.rate) : props.application.rate}
						className="col-md-3"
						disabled={isPremiumReadOnly}
						onChange={props.onPolicyChange}
					/>
					<Checkbox
						label="Overwrite Premium Rate"
						name="overwriteRate"
						className="col-md-3"
						onChange={props.onOverwirteChange}
						checked={props.overwriteRate}
						disabled={props.readOnly}
					/>
				</div>
				<div className="row align-items-center">
					<TextInput labelText="Code" name="code" value={props.application.campaignCode} className="col-md-3" disabled={true} />
				</div>
			</div>
		</div>
	);
};
export default ApplicationDetailsForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/policy/ApplicationDetailsForm.tsx